// components/strategy/StrategyActivateForm.jsx — Phase 3B account
// activation: the invitee pastes the single-use token (from the
// activation link / dev-mode API response) and sets THEIR OWN password.
import React, { useState } from "react";
import { strategyEndpoints } from "../../lib/strategyApi";

export const StrategyActivateForm = ({ onActivated, onCancel }) => {
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) {
      setErr("Les deux mots de passe ne correspondent pas.");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await strategyEndpoints.activate(token.trim(), password);
      onActivated(data.mfa_setup_token);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Lien d'activation invalide, expiré ou déjà utilisé.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="border-2 border-rescue-ink bg-white p-4 space-y-3" data-testid="strategy-activate-form">
      <label className="text-[10px] font-bold tracking-[0.25em] uppercase text-rescue-mute">Jeton d'activation</label>
      <input data-testid="strategy-activate-token" value={token} onChange={(e) => setToken(e.target.value)} autoFocus
        className="w-full border-2 border-rescue-line px-3 py-2 text-sm font-mono" />
      <label className="text-[10px] font-bold tracking-[0.25em] uppercase text-rescue-mute">Nouveau mot de passe</label>
      <input data-testid="strategy-activate-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
        className="w-full border-2 border-rescue-line px-3 py-2 text-sm" />
      <label className="text-[10px] font-bold tracking-[0.25em] uppercase text-rescue-mute">Confirmer le mot de passe</label>
      <input data-testid="strategy-activate-password-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
        className="w-full border-2 border-rescue-line px-3 py-2 text-sm" />
      {err && <div className="text-xs text-rescue-red font-bold" data-testid="strategy-activate-error">{err}</div>}
      <button type="submit" disabled={submitting} data-testid="strategy-activate-submit"
        className="w-full bg-rescue-red text-white py-3 text-xs font-bold uppercase tracking-[0.2em] disabled:opacity-60">
        {submitting ? "Activation…" : "Activer mon compte"}
      </button>
      <button type="button" onClick={onCancel} data-testid="strategy-activate-cancel"
        className="w-full text-[10px] font-bold uppercase tracking-[0.2em] text-rescue-mute hover:text-rescue-ink">
        ← Retour à la connexion
      </button>
    </form>
  );
};
